import { translate } from "../../core/i18n"
import { RoundButton } from "../buttons/base/RoundButton"

export const TaskAreaSwitch = (props) => {
  return <RoundButton icon="list-check" className="m-1" onClick={props.switch} title={translate('view-editor-task-button')} /> 
}